export const CarrierAllTR={
CarrID:{en:'Carrier ID',cs:'CarrID',dataType:'number',format:'#0',required:true},
CarrName:{en:'Carrier Name',cs:'Jméno',dataType:'string',required:true,maxLength:255},
CarrStreet:{en:'Street',cs:'Ulice',dataType:'string',maxLength:255},
CarrCity:{en:'City',cs:'Město',dataType:'string',maxLength:255},
CarrZipNumber:{en:'ZIP Code',cs:'PSČ',dataType:'string',maxLength:255},
CarrContact:{en:'Contact',cs:'Kontakt',dataType:'string',maxLength:255},
CarrTelNr1:{en:'Phone 1',cs:'Tel 1',dataType:'string',maxLength:255},
CarrEmail1:{en:'Email 1',cs:'EMail 1',dataType:'string',maxLength:255},
CarrTelNr2:{en:'Phone 2',cs:'Tel 2',dataType:'string',maxLength:255},
CarrEmail2:{en:'Email 2',cs:'EMail 2',dataType:'string',maxLength:255},
CarrEmail1Sent:{en:'Email 1 Sent',cs:'Sent EMail 1',dataType:'boolean',required:true},
CarrEmail2Sent:{en:'Email 2 Sent',cs:'Sent EMail 2',dataType:'boolean',required:true},
CarrDIC:{en:'VAT ID',cs:'DIČ',dataType:'string',maxLength:255},
CarrRemark:{en:'Remark',cs:'Poznámka',dataType:'string'},
CarrOldID:{en:'CarrOldID',cs:'CarrOldID',dataType:'number',format:'#0'},
CarrTimeStamp:{en:'CarrTimeStamp',cs:'CarrTimeStamp',dataType:'number',format:'#0'},
CarrUserID:{en:'CarrUserID',cs:'CarrUserID',dataType:'number',format:'#0'},
UserLoginName:{en:'Login Name',cs:'',dataType:'string',maxLength:100},
UserFirstName:{en:'UserFirstName',cs:'UserFirstName',dataType:'string',maxLength:50},
UserSurname:{en:'UserSurname',cs:'UserSurname',dataType:'string',maxLength:50},
UserFullName:{en:'Full Name',cs:'',dataType:'string',maxLength:101},
UserEmail:{en:'Email Address',cs:'',dataType:'string',maxLength:255}
}